module.exports = __webpack_public_path__ + "img/water_and_marine_resources.5f0ffaf.svg";